import { LockClosedIcon, LockOpen1Icon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useGetAcademicYearQuery } from "../../hooks/useGetAcademicYearQuery";
import { routes } from "../../routes";
import { createAcademicYear } from "../../services/school/academicYear/createAcademicYear";
import { disableAcademicYear } from "../../services/school/academicYear/disableAcademicYear";
import { updateAcademicYear } from "../../services/school/academicYear/updateAcademicYear";
import { AcademicYearType } from "../../types/AcademicYear";


const columnNamesMap: { [key: string]: string } = {
    year: 'Ano',
    statusString: "Estado"
};
export const AcademicYears = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { data, status } = useGetAcademicYearQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationDisableAcademicYear = useMutation(disableAcademicYear, {
        onSuccess: () => {
            queryClient.invalidateQueries('academicYears-pagination');
            toast.success('Ano desabilitado');
        },
        onError: () => {
            toast.error("Erro ao desabilitar Ano.")
        }
    });

    const mutationCreateAcademicYear = useMutation({ mutationFn: createAcademicYear, "mutationKey": "createAcademicYear" });
    const mutationUpdateAcademicYear = useMutation(updateAcademicYear, {
        onSuccess: () => {
            queryClient.invalidateQueries('academicYears-pagination');
            toast.success('Ano habilitado');
        },
        onError: () => {
            toast.error("Erro ao habilitar Ano.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = async (event: any) => {
        event.preventDefault();
        try {
            await mutationCreateAcademicYear.mutateAsync({ year: new Date().getFullYear().toString() })
            queryClient.invalidateQueries('academicYears-pagination');
            navigate(routes.createAcademicYear);

        }
        catch (error: any) {
            toast.error(`${mutationCreateAcademicYear.error ?? error?.message}`);
        }
    }

    const handleDelete = (academicYear: AcademicYearType) => {

        try {
            mutationDisableAcademicYear.mutateAsync(academicYear.id)
        }
        catch (error: any) {
            toast.error(`${mutationDisableAcademicYear.error ?? error?.message}`);
        }
    };

    const handleActivateYear = async (academicYear: AcademicYearType) => {

        try {
            if (academicYear.status) {
                toast.success("Ano já se encontra activo")
                return;
            }
            academicYear.status = true;
            await mutationUpdateAcademicYear.mutateAsync(academicYear)
        }
        catch (error: any) {
            toast.error(`${mutationUpdateAcademicYear.error ?? error?.message}`);
        }
    };

    const options = data?.items.map(() => [
        {
            label: 'Desabilitar',
            onClick: (academicYear: AcademicYearType) => handleDelete(academicYear),
            icon: <LockClosedIcon />
        },
        {
            label: 'Habilitar',
            onClick: (academicYear: AcademicYearType) => handleActivateYear(academicYear),
            icon: <LockOpen1Icon />
        }
    ]) || [];

    return (
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={['year', "statusString"]}
                    items={
                        data?.items.map(d => {
                            return {
                                ...d,
                                statusString: d.status ? "Activo" : "Desactivado"
                            }
                        })
                    }
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            }
            handleClickCreate={handleClickCreate}
        />
    );
}